module.exports = {"id":"228698","name":"Viktor Kovalenko","rating":"74","photo":"./data/images/photos/4/228698.png","club":{"name":"Chakhtar Donetsk","logo":"./data/images/clubs/ChakhtarDonetsk.png"},"positions":["MOC","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ViktorKovalenko0.json
// module id = 4270
// module chunks = 0